"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const isomorphic_html_sanitize_1 = __importDefault(require("isomorphic-html-sanitize"));
const defaults_1 = __importDefault(require("./defaults"));
const renderer_1 = __importDefault(require("./renderer"));
const inline_1 = __importDefault(require("./grammar/inline"));
const utils_1 = require("./utils");
const log = (0, debug_1.default)('exchange-parser:inline-lexer');
const logEvaluation = (0, debug_1.default)('exchange-parser-evaluation:inline-lexer');
class InlineLexer {
    constructor(links, options) {
        // lexing/compiling
        this.output = (src) => {
            const out = [];
            const { outputLimit } = this.options;
            while (src) {
                log('Receiving src', src.substring(0, 100));
                let cap;
                logEvaluation('evaluating limit');
                if (out.length > outputLimit && (cap = inline_1.default.text.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Text found', cap[0]);
                    if (this.renderer.text) {
                        out.push(...this.renderer.text(this.options.escape(cap[0])));
                    }
                    continue;
                }
                logEvaluation('Evaluating escape');
                cap = inline_1.default.escape.exec(src);
                // escape
                if (cap) {
                    src = src.substring(cap[0].length);
                    log('Escape character found', cap[1]);
                    out.push(cap[1]);
                    continue;
                }
                // code
                logEvaluation('Evaluating code');
                if ((cap = inline_1.default.code.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Code found', cap[2] || cap[1]);
                    if (this.renderer.codespan) {
                        out.push(...this.renderer.codespan(this.options.escape(cap[2] || cap[1])));
                    }
                    continue;
                }
                // autolink
                logEvaluation('Evaluating autolink');
                if ((cap = inline_1.default.autolink.exec(src))) {
                    src = src.substring(cap[0].length);
                    let href;
                    let text;
                    if (cap[2] === '@') {
                        text =
                            cap[1].charAt(6) === ':'
                                ? this.mangle(cap[1].substring(7))
                                : this.mangle(cap[1]);
                        href = this.mangle('mailto:') + text;
                    }
                    else {
                        // eslint-disable-next-line prefer-destructuring
                        text = cap[1];
                        href = text;
                    }
                    log('Autolink found', text, href);
                    if (this.renderer.link) {
                        out.push(...this.renderer.link(href, null, text));
                    }
                    continue;
                }
                // url (gfm)
                logEvaluation('Evaluating url');
                if (!this.inLink && (cap = inline_1.default.url.exec(src))) {
                    src = src.substring(cap[0].length);
                    const text = cap[1];
                    const href = text;
                    log('URL found', text, href);
                    if (this.renderer.link) {
                        out.push(...this.renderer.link(href, null, text));
                    }
                    continue;
                }
                // anchor link
                logEvaluation('Evaluating anchor link');
                if ((cap = inline_1.default.anchorlink.exec(src))) {
                    const { attributes, content: alt } = cap.groups;
                    const href = utils_1.getHTMLAttr.href(attributes);
                    if (href) {
                        src = src.substring(cap[0].length);
                        this.inLink = true;
                        const link = {
                            href,
                            title: utils_1.getHTMLAttr.title(attributes) || alt,
                            target: utils_1.getHTMLAttr.target(attributes)
                        };
                        log('Anchor link found', link);
                        out.push(...this.outputLink(cap, link, alt));
                        this.inLink = false;
                        continue;
                    }
                }
                // markdown link
                logEvaluation('Evaluating markdown link');
                if ((cap = inline_1.default.mdlink.exec(src))) {
                    src = src.substring(cap[0].length);
                    this.inLink = true;
                    const [, alt, href, title] = cap;
                    const link = {
                        href,
                        title
                    };
                    log('Markdown link found', link);
                    out.push(...this.outputLink(cap, link, alt));
                    this.inLink = false;
                    continue;
                }
                // reflink, nolink
                logEvaluation('Evaluating reflink, nolink');
                if ((cap = inline_1.default.reflink.exec(src)) ||
                    (cap = inline_1.default.nolink.exec(src))) {
                    let link;
                    src = src.substring(cap[0].length);
                    link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                    link = this.links[link.toLowerCase()];
                    if (!link || !link.href) {
                        log('Nolink found', cap[0].charAt(0));
                        if (this.renderer.text) {
                            out.push(...this.renderer.text(cap[0].charAt(0)));
                        }
                        src = cap[0].substring(1) + src;
                        continue;
                    }
                    this.inLink = true;
                    log('Reflink found', link);
                    out.push(...this.outputLink(cap, link, cap[1]));
                    this.inLink = false;
                    continue;
                }
                // strong
                logEvaluation('Evaluating strong');
                if ((cap = inline_1.default.strong.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Strong found', cap[4] || cap[3] || cap[2] || cap[1]);
                    if (this.renderer.strong) {
                        out.push(...this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1])));
                    }
                    continue;
                }
                // em
                logEvaluation('Evaluating em');
                if ((cap = inline_1.default.em.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Em found', cap[4] || cap[3] || cap[2] || cap[1]);
                    if (this.renderer.em) {
                        out.push(...this.renderer.em(this.output(cap[4] || cap[3] || cap[2] || cap[1])));
                    }
                    continue;
                }
                // del (gfm)
                logEvaluation('Evaluating del');
                if ((cap = inline_1.default.del.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Del found', cap[4] || cap[3] || cap[2] || cap[1]);
                    if (this.renderer.del) {
                        out.push(...this.renderer.del(this.output(cap[4] || cap[3] || cap[2] || cap[1])));
                    }
                    continue;
                }
                // br
                logEvaluation('Evaluating br');
                if ((cap = inline_1.default.br.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('BR found');
                    if (this.renderer.br) {
                        out.push(...this.renderer.br());
                    }
                    continue;
                }
                // tag
                logEvaluation('Evaluating tag');
                if ((cap = inline_1.default.tag.exec(src))) {
                    if (!this.inLink && /^<a /i.test(cap[0])) {
                        this.inLink = true;
                    }
                    else if (this.inLink && /^<\/a>/i.test(cap[0])) {
                        this.inLink = false;
                    }
                    src = src.substring(cap[0].length);
                    log('Tag found', cap[0]);
                    if (this.renderer.tag) {
                        let sanitizedContent;
                        try {
                            sanitizedContent = (0, isomorphic_html_sanitize_1.default)(cap[0]);
                        }
                        catch (error) {
                            sanitizedContent = '';
                        }
                        out.push(...this.renderer.tag(sanitizedContent));
                    }
                    continue;
                }
                // text
                logEvaluation('Evaluating text');
                if ((cap = inline_1.default.text.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Text found', cap[0]);
                    if (this.renderer.text) {
                        out.push(...this.renderer.text(this.options.escape(cap[0])));
                    }
                    continue;
                }
                if (src) {
                    throw new Error(`Infinite loop on byte: ${src.charCodeAt(0)}`);
                }
            }
            return out;
        };
        this.outputLink = (cap, link, alt) => {
            if (cap[0].charAt(0) !== '!' ||
                cap[0].substring(0, 2).toLowerCase() === '<a') {
                if (this.renderer.link) {
                    return this.renderer.link(link.href, link.title ? this.options.escape(link.title) : '', this.output(alt), link.target ? this.options.escape(link.target) : undefined);
                }
            }
            else if (this.renderer.attachment) {
                return this.renderer.attachment(link.href, link.title ? this.options.escape(link.title) : '', this.options.escape(alt || ''));
            }
            return [];
        };
        this.mangle = (text) => {
            if (!this.options.mangle) {
                return text;
            }
            return (0, utils_1.mangle)(text);
        };
        this.links = links;
        this.options = { ...defaults_1.default, ...options };
        this.renderer = new renderer_1.default(this.options);
        if (!this.links) {
            throw new Error('Tokens array requires a `links` property.');
        }
    }
}
exports.default = InlineLexer;
